<template>
  <md-table :class="{mdCard: mdCard}">
    <md-table-row>
      <md-table-head></md-table-head>
      <md-table-head>無料トライアル</md-table-head>
      <md-table-head>本契約</md-table-head>
    </md-table-row>
    <md-table-row>
      <md-table-cell>期間・料金</md-table-cell>
      <md-table-cell>
        {{ trial.trial_period_days }}日間 <b class="attention">無料</b><br/>
        {{ showCurrentValue ? datetimeFormat(trial.period_use_end, 'YYYY年M月D日 H時まで') : '' }}
        <p class="md-caption">
          ※「本契約の手続き」を行わない限り無料トライアルは15日間で終了し、自動で本契約へ移行することはございません。
        </p>
      </md-table-cell>
      <md-table-cell>1 ID/月<br><b>¥12,000(税抜)</b><br>
        <p class="md-caption">
          ※2ID目以降は、ID数が増えるごとにID単価が減額します。<br>
          <router-link :to="{ name: 'Simulation2' }"><a style="color: blue">料金シミュレーション</a></router-link>でご確認ください。
        </p>
      </md-table-cell>
    </md-table-row>
    <md-table-row>
      <md-table-cell>JON地番地図の閲覧</md-table-cell>
      <md-table-cell>{{ trial.trial_limit_chiban }}枚まで</md-table-cell>
      <md-table-cell><b>無制限</b></md-table-cell>
    </md-table-row>
    <md-table-row>
      <md-table-cell>路線価図の閲覧</md-table-cell>
      <md-table-cell>{{ trial.trial_limit_rosen }}枚まで</md-table-cell>
      <md-table-cell><b>無制限</b></md-table-cell>
    </md-table-row>
    <md-table-row>
      <md-table-cell>登記情報の取得</md-table-cell>
      <md-table-cell>◯
        <p class="md-caption">※登記情報提供サービスIDをお持ちでない場合はサンプルでのお試しとなります。<br>
          ※実際の登記情報の取得には登記情報提供サービスIDが必要となり、取得した場合は登記情報提供サービスの定める料金が発生します。</p>
      </md-table-cell>
      <md-table-cell>◯
        <p class="md-caption">※本契約時は登記情報提供サービスのIDが必要です。<br>
          ※別途、登記情報提供サービスの定める料金が発生します。<br>
          ※取得した登記情報は何度でも閲覧可能です。</p>
      </md-table-cell>
    </md-table-row>
    <md-table-row>
      <md-table-cell>ユーザーの追加と管理</md-table-cell>
      <md-table-cell>✕</md-table-cell>
      <md-table-cell>◯</md-table-cell>
    </md-table-row>
    <md-table-row>
      <md-table-cell>支払方法</md-table-cell>
      <md-table-cell>-</md-table-cell>
      <md-table-cell>クレジットカード/銀行振込</md-table-cell>
    </md-table-row>
  </md-table>
</template>

<script>
import CommonMixin                                  from "../../mixins/commonMixin";
import {apiClient, apiClientWithUserToken, apiList} from '../../modules/apiClient';

export default {
  name   : 'PlanTable',
  mixins : [CommonMixin],
  props  : {
    mdCard          : {
      type   : Boolean,
      default: false,
    },
    showCurrentValue: {
      type   : Boolean,
      default: false,
    }
  },
  data   : () => ({
    trial: {},
    main : {},
  }),
  mounted: function () {
    this.getTrialLatestInfo();
  },
  methods: {
    getTrialLatestInfo() {
      apiClientWithUserToken.get(this.showCurrentValue ? apiList.trial.current_info : apiList.trial.latest_info)
          .then(response => {
            if (this.hasResponseErrors(response)) {
              return;
            }
            const result = response.data;
            this.trial   = result.trial;
            this.main    = result.main;
            this.$emit('loading-complete-plan', {
              trial: this.trial,
              main : this.main,
            });
          })
          .catch(error => {
            this.errorMessages = [error.message];
          });
    },
  },
}
</script>

<style lang="scss" scoped>
.md-table {
  margin-top: 10px;
  margin-bottom: 40px;
  text-align: center;

  ::v-deep(.md-table-head-container) {
    text-align: center;
  }

  .md-table-head:nth-child(2),
  .md-table-head:nth-child(3) {
    width: 33%;
    border-left-width: 1px;
    border-left-style: solid;
    border-left-color: var(--md-theme-default-divider-on-background, rgba(0, 0, 0, 0.12));;
  }

  .md-table-cell {
    vertical-align: middle;
  }

  .md-table-cell:nth-child(2),
  .md-table-cell:nth-child(3) {
    border-left-width: 1px;
    border-left-style: solid;
    border-left-color: var(--md-theme-default-divider-on-background, rgba(0, 0, 0, 0.12));;
  }

  .md-table-head:nth-child(1),
  .md-table-cell:nth-child(1) {
    border-left-width: 1px;
    border-left-style: solid;
    border-left-color: var(--md-theme-default-divider-on-background, rgba(0, 0, 0, 1.0));;
  }

  .md-table-row {
    border-right-width: 1.5px;
    border-right-style: solid;
    border-right-color: var(--md-theme-default-divider-on-background, rgba(0, 0, 0, 0.5));;
  }

  .md-table-row:nth-child(5) {
    .md-table-cell:nth-child(2),
    .md-table-cell:nth-child(3) {
      vertical-align: top;
    }
  }

  .md-table-head:nth-child(1) {
    width: 25%;
  }

  .md-table-head:nth-child(2),
  .md-table-head:nth-child(3) {
    width: 37.5%;
  }

  ::v-deep(tbody .md-table-row .md-table-head .md-table-head-container) {
    vertical-align: middle !important;
    padding: 14px 0;
  }

  .attention {
    color: #ff4b00;
  }
}
.md-attention {
  color: #ff5252;
}
</style>
